module.exports = __webpack_public_path__ + "img/logo.995275e3.png";